/**
 * (bnikom)
 * a component to have user coming from link navigation
 * will always end up at the top of the page.
 * this solution is recommended by the creator of react-router
 * https://reacttraining.com/react-router/web/guides/scroll-restoration
 */

import { Component } from 'react';
import { withRouter } from 'react-router';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
